import React from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import { TextAreaInput, SaveLoaderWrapper, SaveLoaderTitle } from './TextArea.elements'

// Shared Styled Elements
import { Wrapper, Label } from '../SharedStyles.element'

// Assets
import { DownloadIcon } from 'assets/images/Icons'

function TextArea(props) {
  // Destructure
  const { type, label, resize, saveLoading, disabled, ...rest } = props

  return (
    <Wrapper label={label}>
      {label && <Label disabled={disabled}>{label}</Label>}
      <TextAreaInput disabled={disabled} type={type} resize={resize} {...rest} />
      {saveLoading && (
        <SaveLoaderWrapper>
          <SaveLoaderTitle>Saving...</SaveLoaderTitle>
          <DownloadIcon size={18} />
        </SaveLoaderWrapper>
      )}
    </Wrapper>
  )
}

// Default Props
TextArea.defaultProps = {
  type: '',
  label: '',
  resize: true,
  saveLoading: false,
  disabled: false,
}

// Proptypes Validation
TextArea.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  resize: PropTypes.bool,
  saveLoading: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default TextArea
